import { CommonSlice } from '.'
import { AppDispatch } from '../../index'
import { IAllergen, IFetchTableData, ITable } from './types'
import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'

export const getAllergens = () => async (dispatch: AppDispatch) => {
  const allergens: IAllergen[] = await qrMenuGET.allergens()
  dispatch(CommonSlice.actions.setAllergens(allergens))
}

export const getTableData =
  (params: IFetchTableData) => async (dispatch: AppDispatch) => {
    const { caption, table } = params
    const tableData: ITable[] = await qrMenuGET.tableInfo(caption, table)
    dispatch(CommonSlice.actions.setTableData(tableData[0]))
  }
